import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';

export interface ProxyApiClientOptions {
  discoveryApi: DiscoveryApi;
  identityApi: IdentityApi;
  pluginName?: string;
  proxyPath: string;
}

export class ProxyApiClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;
  private readonly pluginName: string;
  private readonly proxyPath: string;

  constructor(opts: ProxyApiClientOptions) {
    this.discoveryApi = opts.discoveryApi;
    this.identityApi = opts.identityApi;
    this.pluginName = opts.pluginName || 'proxy';
    this.proxyPath = opts.proxyPath;
  }

  async fetch<T = any>(input: string, init?: RequestInit): Promise<T> {
    const apiUrl = await this.apiUrl();
    const authedInit = await this.addAuthHeaders(init || {});

    const resp = await fetch(`${apiUrl}${input}`, authedInit);
    if (!resp.ok) {
      throw new Error(`Request failed with ${resp.status} ${resp.statusText}`);
    }

    return await resp.json();
  }

  private async apiUrl() {
    const proxyUrl = await this.discoveryApi.getBaseUrl(this.pluginName);
    return proxyUrl + this.proxyPath;
  }

  private async addAuthHeaders(init: RequestInit): Promise<RequestInit> {
    const authToken = await this.identityApi.getCredentials();
    const headers = init.headers || {};

    return {
      ...init,
      headers: {
        ...headers,
        ...(authToken ? { Authorization: `Bearer ${authToken.token}` } : {}),
      },
    };
  }
}
